window.BritaPasswordUtils = window.BritaPasswordUtils || {};

/**
 * Validates that a `return_to` value is a safe, same-origin relative path,
 * to prevent an open-redirect (e.g. `//evil.example` or `https://evil.example`
 * being used to redirect the visitor off-site after unlocking the storefront
 * or logging in).
 */
window.BritaPasswordUtils.isSafeReturnTo = (value) => {
  if (typeof value !== 'string' || value === '') {
    return false;
  }
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return false;
  }

  try {
    const resolved = new URL(value, window.location.origin);
    return resolved.origin === window.location.origin;
  } catch {
    return false;
  }
};
